module.exports = new __parcel__URL__("jsm-try-end-learn.07226de3.svg").toString();